import Cookies from "js-cookie";

export const SIMLY_PARTNER_API_URL = process.env.REACT_APP_API_URL as string;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY as string;
export const CAMPAIGN_ID = process.env.REACT_APP_CAMPAIGN_ID as string;
export const CAMPAIGN_DEEP_LINK_URL = process.env.REACT_APP_CAMPAIGN_DEEP_LINK_URL as string;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string;
export const SIMLY_HEATMAP_API_URL = process.env.REACT_APP_HEATMAP_API_URL as string;

export const getAccessToken = (): string | undefined => {
    return Cookies.get('token');
}
